var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChorusone = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 36,
    viewBox: "0 0 134 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_38_60",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.5 0H0.5V36H133.5V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_38_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.9408 16.1639C54.4819 16.1639 57.2382 14.4104 57.552 10.4762H54.2798C53.8093 12.4546 52.5544 13.2639 50.9408 13.2639C48.1841 13.2639 47.086 11.0158 47.086 8.0707C47.086 5.1257 48.2068 2.9001 50.9408 2.9001C52.5767 2.9001 53.8093 3.7094 54.2798 5.6652H57.552C57.2382 1.7535 54.4819 0 50.9408 0C46.5033 0 43.6348 2.99 43.6348 8.0707C43.6348 13.174 46.5033 16.1639 50.9408 16.1639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7389 16.1639C86.2659 16.1639 89.2239 12.8817 89.2239 8.0707C89.2239 3.2373 86.2659 0 81.7389 0C77.2119 0 74.2529 3.2373 74.2529 8.0707C74.2529 12.8817 77.2119 16.1639 81.7389 16.1639ZM81.7389 13.2639C79.1609 13.2639 77.7039 11.1956 77.7039 8.0707C77.7039 4.9234 79.1609 2.9001 81.7389 2.9001C84.3159 2.9001 85.7719 4.9234 85.7719 8.0707C85.7719 11.1956 84.3159 13.2639 81.7389 13.2639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.947 16.164C115.757 16.164 118.401 14.1632 118.401 9.95919V0.202393H115.017V9.71189C115.017 12.0499 113.874 13.2414 111.947 13.2414C110.02 13.2414 108.854 12.0499 108.854 9.71189V0.202393H105.47V9.95919C105.47 14.1632 108.092 16.164 111.947 16.164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.955 16.1639C130.518 16.1639 133.319 14.7027 133.319 11.308C133.319 8.925 131.907 7.5087 128.232 6.8118L126.125 6.4071C124.713 6.1598 124.332 5.3955 124.332 4.6761C124.332 3.7094 125.005 2.7877 126.797 2.7877C128.322 2.7877 129.487 3.4171 129.442 4.8334H132.893C132.893 1.6186 130.338 0 126.753 0C123.234 0 120.814 1.5287 120.814 4.5412C120.814 7.3963 122.898 8.5203 125.363 9.0149L127.627 9.4421C129.039 9.7118 129.756 10.2514 129.756 11.3305C129.756 12.6119 128.792 13.3763 126.977 13.3763C124.825 13.3763 123.929 12.2072 123.862 10.7909H120.388C120.388 14.2531 122.943 16.1639 126.955 16.1639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3699 0.360107V6.72901H66.0688V9.47121H69.3699V15.8401H72.7508V0.360107H69.3699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1932 6.72901V9.47121V15.8401H59.811V0.360107H63.1932V6.72901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.436 35.6399H74.499V20.1599H85.212V23.0348H77.861V26.5067H84.539V29.0941H77.861V32.7651H85.436V35.6399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1202 35.9641C55.6472 35.9641 58.6052 32.6818 58.6052 27.8708C58.6052 23.0373 55.6472 19.8 51.1202 19.8C46.5932 19.8 43.6348 23.0373 43.6348 27.8708C43.6348 32.6818 46.5932 35.9641 51.1202 35.9641ZM51.1202 33.0639C48.5429 33.0639 47.086 30.9957 47.086 27.8708C47.086 24.7234 48.5429 22.7001 51.1202 22.7001C53.6972 22.7001 55.154 24.7234 55.154 27.8708C55.154 30.9957 53.6972 33.0639 51.1202 33.0639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.510254 31.9936L4.52155 35.9928L8.53296 31.9936L4.52155 27.9944L0.510254 31.9936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6123 3.9992L32.6007 0L28.5894 3.9992L32.6007 7.9985L36.6123 3.9992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5725 21.9955L18.5611 25.9948L14.5498 21.9955L10.5384 17.9963L14.5498 13.9971L18.5611 9.99777L22.5725 13.9971L26.5838 17.9963L22.5725 21.9955ZM34.6066 17.9962L30.5952 13.997L26.5838 9.99767L22.5724 5.99847L18.5611 1.99927L14.5497 5.99847L10.5383 9.99767L6.52702 13.997L2.51562 17.9962L6.52702 21.9954L10.5383 25.9947L14.5497 29.9939L18.5611 33.9931L22.5724 29.9939L26.5838 25.9947L30.5952 21.9954L34.6066 17.9962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.585 32.0007L32.5963 35.9999L36.6076 32.0007L32.5963 28.0015L28.585 32.0007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5228 4.00262L4.5114 0.00341797L0.5 4.00262L4.5114 8.00192L8.5228 4.00262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0962 20.1599H59.811V35.6399H63.0952V25.6664L63.0962 20.1599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9712 30.3044L69.2042 35.6399H72.7512V20.1599H69.4672V30.3325H69.4012L65.9712 24.6817V30.3044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.411 10.2515L103.705 15.9392H100.389L97.4591 10.7911V7.77849C99.2921 7.77639 100.097 6.85519 100.097 5.46299C100.097 4.04669 99.2901 3.12489 97.4531 3.12489H94.5841V6.63689V11.0895V15.9392H91.2231V0.202393H97.5651C101.733 0.202393 103.549 2.38309 103.549 5.46299C103.549 7.71109 102.585 9.46459 100.411 10.2515Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChorusone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chorusone.01fddb1fa3f56989fa84b96e0ea64c3f.svg";